<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => {
        const files = cannedMessage.files || [];
        return {
          label: cannedMessage.short_code,
          key: cannedMessage.short_code,
          description: cannedMessage.content,
          files,
          hasAttachments: files.length > 0,
        };
      });
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', {
        content: item.description,
        files: item.files || [],
      });
    },
    cannedKey(item = {}) {
      return `/${item.label}`;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  >
    <template #default="{ item, selected }">
      <p
        class="max-w-full min-w-0 mb-0 overflow-hidden text-sm font-medium text-n-slate-11 group-hover:text-n-slate-12 text-ellipsis whitespace-nowrap flex items-center gap-1"
        :class="{ 'text-n-slate-12': selected }"
      >
        {{ item.description }}
        <fluent-icon
          v-if="item.hasAttachments"
          data-testid="canned-attachment-icon"
          icon="attach"
          size="14"
          class="ml-1 text-n-slate-10 flex-shrink-0"
        />
      </p>
      <p
        class="max-w-full min-w-0 mb-0 overflow-hidden text-xs text-n-slate-11 group-hover:text-n-slate-12 text-ellipsis whitespace-nowrap"
        :class="{ 'text-n-slate-12': selected }"
      >
        {{ cannedKey(item) }}
      </p>
    </template>
  </MentionBox>
</template>
